import React from 'react';
import { useOnboarding } from '../../context/OnboardingContext';
import InitialSelection from './steps/InitialSelection';
import UserBusinessIdea from './steps/UserBusinessIdea';
import UserBioForm from './steps/UserBioForm';
import BusinessIdeaReview from './steps/BusinessIdeaReview';
import OnboardingStepWrapper from './OnboardingStepWrapper';
import GenerateBusinessIdeas from '../GenerateBusinessIdeas';
import LoadingPage from '../LoadingPage';
import { Button } from '@mui/material';

const OnboardingFlow: React.FC = () => {
  const { state, setStep } = useOnboarding();

  // Render the appropriate step based on current state
  switch (state.currentStep) {
    case 'initial-selection':
      return <InitialSelection />;

    case 'user-business-idea':
      return <UserBusinessIdea />;

    case 'business-idea-review':
      return <BusinessIdeaReview />;

    case 'user-bio-form':
      return <UserBioForm />;

    case 'processing': {
      // Determine the appropriate loading message based on processing type
      const isGeneratingBusinessIdeas = state.data.processingType === 'generating-business-ideas';

      return (
        <LoadingPage
          title={
            isGeneratingBusinessIdeas ? 'Generating Business Ideas' : 'Enhancing Your Business Idea'
          }
          subtitle={
            isGeneratingBusinessIdeas
              ? 'Our AI is analyzing your profile and creating personalized business opportunities'
              : 'Our AI is analyzing your input and generating a comprehensive business plan'
          }
          size="large"
        />
      );
    }

    case 'error':
      return (
        <OnboardingStepWrapper
          title="Something went wrong"
          subtitle={state.error || 'We encountered an error processing your request'}
          showBackButton={true}
        >
          <div className="text-center space-y-4">
            <p className="text-gray-300">
              {state.error || 'An unexpected error occurred. Please try again.'}
            </p>
            <Button
              variant="contained"
              onClick={() => setStep('user-business-idea')}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Try Again
            </Button>
          </div>
        </OnboardingStepWrapper>
      );

    case 'business-ideas-selection':
      return <GenerateBusinessIdeas isOnboarding={true} />;

    default:
      return (
        <OnboardingStepWrapper
          title="Unknown Step"
          subtitle="Something went wrong..."
          showBackButton={true}
        >
          <div className="text-center">
            <p className="text-gray-300">Please try refreshing the page</p>
          </div>
        </OnboardingStepWrapper>
      );
  }
};

export default OnboardingFlow;
